//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        allowedSchoolNumbers: Array,
        playThroughDefault: Boolean,
        states: Object
    },

    data () {
        return {
            tableLoading: false,
            tableData: [],
            pagination: {},
            tableSorting: ''
        };
    },

    computed: {
        params: function () {
            let params = {};

            if (this.tableSorting !== '' && this.tableSorting !== 'null|asc') {
                params.sort = this.tableSorting;
            }

            params.limit = this.pagination.perPage;
            params.page = this.pagination.currentPage;

            params.with = ['creator'];

            return params;
        }
    },

    mounted () {
        this.loadData();
    },

    methods: {
        loadData () {
            this.tableLoading = true;

            axios.get('classrooms', {
                params: this.params
            })
                .then(response => {
                    this.tableData = response.data.data;
                    this.pagination = this.$helper.getPaginationData(response);
                })
                .catch(error => {
                    console.log(error);
                })
                .then(() => {
                    this.tableLoading = false;
                })
                .catch(error => {
                    console.log(error);
                });
        },

        goToPage (page) {
            this.pagination.currentPage = page;
            this.loadData();
        },

        handleTableSort (data) {
            let order = 'asc';

            if (data.order === 'descending') {
                order = 'desc';
            }

            this.tableSorting = data.prop + '|' + order;
            this.loadData();
        },

        handleCreateClassroom () {
            this.$refs['classroomForm'].setItem(false);
            this.$refs['classroomForm'].show();
        },

        handleEditClassroom (row) {
            this.$refs['classroomForm'].setItem(row);
            this.$refs['classroomForm'].show();
        },

        showImportSchoolNumbersDialog () {
            this.$refs['schoolImportForm'].show();
        },

        exportCodes (classroom) {
            window.open('/classes/' + classroom.id + '/export', '_blank');
        },
    }
};
